/** import custom dependency [start] */
import { getData, postData } from '../';
import URL from '../../utils/baseUrls';
import { PayloadTypes } from '../types';
/** import custom dependency [end] */

/**
 * Get the Network list form the backend
 * @param networkType Netowrk type
 * @param nodeType Node type
 * @returns
 */
export const getNetworkList = async (networkType: string, nodeType: string) => {
    const res = await getData(URL.getNetworkListUrl(networkType, nodeType));
    return res;
};

/**
 * To create a new network
 * @param payload
 * @returns
 */
export const createNetwork = async (payload: PayloadTypes.CreateNetworkPayload) => {
    const res = await postData(URL.getCreateNetworkUrl(), payload);
    return res;
};

/**
 * To delete a new network
 * @param networkId
 * @returns
 */
export const deleteNetwork = async (networkId: string | number) => {
    const res = await getData(URL.deleteNetworkById(networkId));
    return res;
};

/**
 * To create a new staking network
 * @param payload
 * @returns
 */
export const createStakingNetwork = async (payload: PayloadTypes.AddStakingNodePayload) => {
    const res = await postData(URL.getCreateNetworkUrl(), payload);
    return res;
};

/**
 * To get the network details
 * @param networkId
 * @returns
 */
export const getNetworkDetail = async (networkId: string | number) => {
    const res = await getData(URL.getNetworkDetails(networkId));
    return res;
};

/**
 * To get node details
 * @param networkId
 * @returns
 */
export const getAllNodes = async (networkId: string | number) => {
    const res = await getData(URL.getAllNodes(networkId));
    return res;
};

/**
 * To get block height details
 * @param networkId
 * @param id
 * @returns
 */
export const getBlockHeight = async (networkId: string | number, id: string) => {
    const res = await getData(URL.getNodeInfoUrl(networkId, id));
    return res;
};
